import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import AlertBox from "../../component/AlertBox";
import { LinearProgress } from "@mui/material";
import AccrodianBox from "../../component/AccrodianBox";
import axios from "axios";
import { SERVER_URL } from "../../constant";
import InputField from "../../component/InputField";
import ButtonCompo from "../../component/ButtonCompo";
import SelectField from "../../component/SelectField";
import DialogBox from "../../component/DialogBox";

function SalaryStructure() {
  const isEmployee = useSelector(
    (state) => state.employee?.isEmployeeAuthenticated
  );
  const employeeData = useSelector((state) => state.employee?.employeeData);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [prevSalaryStructure, setPrevSalaryStructure] = useState([]);
  const [newSalaryStructure, setNewSalaryStructure] = useState([]);
  const [name, setName] = useState("");
  const [value, setValue] = useState(0);
  const [amountType, setAmountType] = useState("");
  const [isEnable, setIsEnable] = useState(true);
  const [isDeduction, setIsDeduction] = useState(false);
  const [isShowInPayslip, setIsShowInPayslip] = useState(true);

  const navigate = useNavigate();

  //redirect to signin if not logged in
  useEffect(() => {
    if (isEmployee !== undefined && isEmployee === false) {
      navigate("/employee/signin");
    }
  }, [isEmployee]);

  //redirect to employee dashboard if permission is not given
  useEffect(() => {
    if (
      employeeData !== null &&
      employeeData?.admin?.salaryStructureCreation === false
    ) {
      navigate("/employee/dashboard");
    }
  }, [employeeData]);

  /* ----------------------------------------------------------------------------------------------------- */
  /* ----------------------------------------Main Coding Part--------------------------------------------- */
  /* ----------------------------------------------------------------------------------------------------- */

  //fetch all salary structure
  async function getStructure() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/get/salary-structure`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setPrevSalaryStructure(res.data?.data);
      setNewSalaryStructure(res.data?.data);
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Salary structure fetch failed");
    } finally {
      setLoading(false);
    }
  }

  // a structure of the actual objects
  const structure = {
    name: "Untitled",
    amountType: "percentage",
    value: 0,
    isEnable: true,
    isDeduction: false,
    isShowInPayslip: true,
  };

  // select fields value arrays
  const amountTypeValues = [
    {
      title: "Percentage",
      value: "percentage",
    },
    {
      title: "Amount",
      value: "amount",
    },
  ];

  const isEnableValues = [
    {
      title: "Yes",
      value: true,
    },
    {
      title: "No",
      value: false,
    },
  ];

  const isDeductionValues = [
    {
      title: "Yes",
      value: true,
    },
    {
      title: "No",
      value: false,
    },
  ];

  const isShowInPayslipValues = [
    {
      title: "Yes",
      value: true,
    },
    {
      title: "No",
      value: false,
    },
  ];

  // add new field to the array
  function addNewField() {
    setNewSalaryStructure((prev) => {
      return [...prev, structure];
    });
  }

  // delete a field from the array
  function deleteAField(id) {
    setNewSalaryStructure((prev) => {
      let prevArray = prev;
      //slice works with the length value
      //cut first part of array, from start to before element of targeted element
      const firstPart = prevArray.slice(0, id);
      //cut last part of array, from just after the targeted element to last element
      const lastPart = prevArray.slice(id + 1, prevArray.length);
      //join them in a new array
      const newArray = [...firstPart, ...lastPart];
      // return the new array
      return newArray;
    });
  }

  // Updating field value from direct array
  function updateArray(index) {
    const newObj = {
      name,
      value: 0,
      amountType: "",
      isEnable,
      isDeduction,
      isShowInPayslip,
    };

    setNewSalaryStructure((prev) => {
      let prevArray = [...prev];
      prevArray[index] = newObj;
      return prevArray;
    });
  }

  // change state when user open dialog box to show previous value in the input field. "defaultValue" attribute is not reliable.
  function setDefaultValue(data) {
    setName(data?.name);
    setIsEnable(data?.isEnable);
    setIsDeduction(data?.isDeduction);
    setIsShowInPayslip(data?.isShowInPayslip);
  }

  //update the salary structure from backend
  async function updateSalaryStructure() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/update/salary-structure`,
        method: "put",
        data: {
          salaryStructure: newSalaryStructure,
        },
        withCredentials: true,
      });
      if (res.status >= 200 || res.status < 400) {
        setOpen(true);
        setSuccess(true);
        setMessage("Salary structure updated successfully");
      }
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // set as default
  function setAsDefault() {
    setNewSalaryStructure(prevSalaryStructure);
  }

  useEffect(() => {
    getStructure();
  }, []);

  //console.log(amountType);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] lg:w-[50rem] py-5">
          <h1 className="text-[20px] sm:text-[30px] font-medium text-left w-full">
            Salary Structure Configuration
          </h1>
          <div className="w-full justify-end flex gap-3 mt-5 flex-wrap">
            <ButtonCompo onClick={addNewField}>Add New Field</ButtonCompo>
            <ButtonCompo onClick={setAsDefault}>set as default</ButtonCompo>
          </div>
          <div className="mt-5 w-full">
            {newSalaryStructure?.map((e, i) => (
              <AccrodianBox title={e?.name} id={i} key={i}>
                <div className="w-full space-y-3">
                  <div className="grid grid-cols-1 gap-3">
                    <InputField label="Name" value={e?.name} readOnly />
                  </div>
                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                    {/* <SelectField
                      label={"Amount Type"}
                      valueArray={amountTypeValues}
                      value={e?.amountType}
                      readOnly
                    /> */}
                    <SelectField
                      label={"Enable"}
                      value={e?.isEnable}
                      valueArray={isEnableValues}
                      readOnly
                    />
                    <SelectField
                      label={"Is This A Deducted Field?"}
                      valueArray={isDeductionValues}
                      value={e?.isDeduction}
                      readOnly
                    />
                    <SelectField
                      label={"Show In Payslip"}
                      valueArray={isShowInPayslipValues}
                      value={e?.isShowInPayslip}
                      readOnly
                    />
                  </div>
                  <div className="w-full flex justify-end">
                    <ButtonCompo
                      onClick={() => deleteAField(i)}
                      color={"error"}
                    >
                      Delete
                    </ButtonCompo>
                    <DialogBox
                      trigger={
                        <ButtonCompo onClick={() => setDefaultValue(e)}>
                          Edit
                        </ButtonCompo>
                      }
                      title={`Edit ${e?.name}`}
                      actionButton={
                        <ButtonCompo onClick={() => updateArray(i)}>
                          Save Changes
                        </ButtonCompo>
                      }
                      closeActionButton="Cancel"
                      maxWidth="sm"
                    >
                      <div className="w-full space-y-3">
                        <div className="grid grid-cols-1 gap-3">
                          <InputField
                            label="Name"
                            value={name}
                            onChange={(ev) => setName(ev?.target?.value)}
                          />
                          {/* <InputField
                            label="Value"
                            value={value}
                            onChange={(ev) => setValue(ev?.target?.value)}
                          /> */}
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                          {/* <SelectField
                            label={"Amount Type"}
                            valueArray={amountTypeValues}
                            value={amountType}
                            setValue={(ev) => setAmountType(ev?.target?.value)}
                          /> */}
                          <SelectField
                            label={"Enable"}
                            value={isEnable}
                            valueArray={isEnableValues}
                            setValue={(ev) => setIsEnable(ev?.target?.value)}
                          />
                          <SelectField
                            label={"Is This A Deducted Field?"}
                            valueArray={isDeductionValues}
                            value={isDeduction}
                            setValue={(ev) => setIsDeduction(ev?.target?.value)}
                          />
                          <SelectField
                            label={"Show In Payslip"}
                            valueArray={isShowInPayslipValues}
                            value={isShowInPayslip}
                            setValue={(ev) => setIsShowInPayslip(ev?.target?.value)}
                          />
                        </div>
                      </div>
                    </DialogBox>
                  </div>
                </div>
              </AccrodianBox>
            ))}
          </div>
          <div className="w-full justify-end flex mt-5">
            <ButtonCompo onClick={updateSalaryStructure} variant={"contained"}>
              Save Changes
            </ButtonCompo>
          </div>
        </div>
      </div>
    </>
  );
}

export default SalaryStructure;
